import type { FunnelStageEnum, HireJobsApplicantsListParams } from "@sidegigllc/api/client";
import type { ApplicantSearch } from "routing/tree/hire";

/** Build the applicants-list query params from the URL search params. Shared by the JobDetails container and
 * its route loader so their React Query keys match — a loader prefetch only warms the list the container reads
 * if the key is identical (funnel_stage + every filter). `funnelStage` is passed in so the container can apply
 * its OFF-posting guard; the loader passes the raw URL value. */
export const toApplicantListParams = (
  params: ApplicantSearch,
  funnelStage: FunnelStageEnum,
): HireJobsApplicantsListParams => {
  const {
    ordering,
    funnel_stage: _funnelStage,
    applicant_id: _applicantId,
    offerType: _offerType,
    favorites,
    ...candidateFilters
  } = params;
  return {
    ordering,
    funnel_stage: funnelStage,
    ...candidateFilters,
    is_preferred: favorites,
  } as HireJobsApplicantsListParams;
};
